<div class="p-container">
  <div class="flex flex-row justify-between mb-4 p-3">
    <span class="text-foreground text-2xl font-bold">Payment History List</span>
    <div class="flex gap-2">
      <p-button
        label="Reset Filters"
        icon="pi pi-refresh"
        severity="secondary"
        [outlined]="true"
        (onClick)="resetFilters()"
      />
    </div>
  </div>
  <app-table
   *ngIf="patientId"
    [columns]="column"
    [getDataFunc]="loadData"
    [componentInstance]="this"
    [paginationPageSize]="paging.pageSize || 10"
  >
  </app-table>
   <ng-template #statusTemplate let-row>
      <span class="badge" [ngClass]="getStatusClass(row.payment_status)">
        {{ getPaymentStatus(row.payment_status) }}
      </span>
    </ng-template>

     <ng-template #PaymentTemplate let-row>
      <span  >
        {{ getPaymentType(row.charge_type) }}
      </span>
    </ng-template>

    <ng-template #paymentMethodTemplate let-row>
      <span  >
        {{ getPaymentMethod(row.payment_method) }}
      </span>
    </ng-template>





</div>
